import { render, staticRenderFns } from "./ListUploadArea.vue?vue&type=template&id=61fc9066"
import script from "./ListUploadArea.vue?vue&type=script&lang=js"
export * from "./ListUploadArea.vue?vue&type=script&lang=js"
import style0 from "./ListUploadArea.vue?vue&type=style&index=0&id=61fc9066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports